'use client';

import {useEffect} from "react";

interface Props {
    content: string;
}

export default function WithTwitter({content}: Props){
    useEffect(() => {
        /**
         * Charger le script twitter pour afficher les tweets
         */
        const script = document.createElement('script');

        script.src = 'https://platform.twitter.com/widgets.js';
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [content]);

    return (<></>)
}


